module.exports = __webpack_public_path__ + "static/media/sort-alt.d0b735f5.svg";